// ─── BLOOM STORE TEMPLATES ────────────────────────────────────────────────────
// T = inline style values for things CSS vars can't reach (header bg, etc.)
// scopedCSS = injected as <style> scoped to .theme-X wrapper class

const THEMES = {
  default: {
    T: {
      headerBg: "var(--white)",
      headerText: "var(--ink)",
      accent: "#2F63DD",
      accentFg: "#fff",
      radius: "4px",
      badgeRadius: "2px",
      dark: false,
      brutalistShadow: "none",
      cardLayout: "default",
    },
    bodyBg: "#F4F3EE",
    scopedCSS: "",
  },

  neutral: {
    T: {
      headerBg: "#FAFAFA",
      headerText: "#000000",
      accent: "#000000",
      accentFg: "#FFFFFF",
      radius: "0px",
      badgeRadius: "0px",
      dark: false,
      brutalistShadow: "none",
      cardLayout: "reformation",
    },
    bodyBg: "#FFFFFF",
    scopedCSS: `
      /* New Bloom type system: Syne for text, Instrument Serif for headlines (fonts come from FontLoader). */
      .theme-neutral { font-family:'Syne',sans-serif; }
      .theme-neutral h1,.theme-neutral h2 { font-family:'Instrument Serif',Georgia,serif; font-weight:400; letter-spacing:-0.015em; line-height:.95; text-transform:uppercase; }
      .theme-neutral h3,.theme-neutral h4 { font-family:'Syne',sans-serif; font-weight:700; letter-spacing:-0.01em; }
      .theme-neutral em { font-family:'Instrument Serif',Georgia,serif; font-style:italic; }
      .theme-neutral .btn-pink,.theme-neutral .btn-green,.theme-neutral .btn-ghost,.theme-neutral .btn-yellow { font-family:'Syne',sans-serif !important; letter-spacing:0.04em; }
      .theme-neutral .inp { font-family:'Syne',sans-serif !important; }
      .theme-neutral {
        --offwhite:#FAFAFA; --white:#FFFFFF; --surface:#F5F5F5;
        --border:rgba(0,0,0,0.08); --border-mid:rgba(0,0,0,0.14);
        --ink:#000000; --ink-soft:rgba(0,0,0,0.44);
        --teal:#000000; --teal-deep:#000000; --teal-light:#F0F0F0; --teal-mid:rgba(0,0,0,0.10);
        --pink:rgba(0,0,0,0.04); --pink-deep:rgba(0,0,0,0.08);
        --pink-btn:#000000; --pink-btn-h:#333333;
        --blue:rgba(0,0,0,0.04); --yellow:rgba(0,0,0,0.04);
        --r:0px; --shadow-sm:none;
        /* semantic + highlight tokens (same names the Bloom look uses), kept monochrome */
        --head-bg:#F5F5F5; --row-line:rgba(0,0,0,0.07); --sel-bg:rgba(0,0,0,0.04);
        --on-accent:#FFFFFF; --on-ink:#FFFFFF; --butter:#F1EFE6; --butter-deep:#E6E3D6;
        --grad-hero:#F5F5F5; --grad-accent:#000000; --grad-warm:#F5F5F5; --grad-promo:#F1EFE6;
      }
      .theme-neutral .btn-pink,.theme-neutral .btn-green {
        background:#000000 !important; color:#fff !important;
        border-radius:0px !important; box-shadow:none !important; }
      .theme-neutral .btn-pink:hover,.theme-neutral .btn-green:hover { background:#222 !important; transform:none !important; opacity:1 !important; }
      .theme-neutral .btn-ghost,.theme-neutral .btn-yellow { border-radius:0px !important; box-shadow:none !important; }
      .theme-neutral .btn-ghost { border-color:rgba(0,0,0,0.3) !important; color:#000 !important; }
      .theme-neutral .btn-ghost:hover { background:rgba(0,0,0,0.05) !important; border-color:#000 !important; transform:none !important; }
      .theme-neutral .inp { border-radius:0px !important; border:1px solid rgba(0,0,0,0.18) !important; }
      .theme-neutral .inp:focus { box-shadow:none !important; border-color:#000 !important; transform:none !important; }
      .theme-neutral .pill { border-radius:0px !important; background:#000 !important; color:#fff !important; font-family:'Syne',sans-serif !important; }
      .theme-neutral .card { border-radius:0px !important; box-shadow:none !important; border:1px solid rgba(0,0,0,0.08) !important; }
      .theme-neutral .upi-btn { border-radius:0px !important; }
      .theme-neutral .upi-btn:hover { border-color:#000 !important; background:#F0F0F0 !important; color:#000 !important; }
      .theme-neutral .upload-zone { border-radius:0px !important; }
      .theme-neutral .bdg-green { border-radius:0px !important; background:#F0F0F0 !important; color:#000 !important; border:1px solid rgba(0,0,0,0.12) !important; }
      .theme-neutral .storefront-hero { border-bottom:1px solid rgba(0,0,0,0.08) !important; }
      .theme-neutral .storefront-hero h1 { font-size:clamp(32px,5.6vw,60px) !important; letter-spacing:-0.015em !important; font-weight:400 !important; }
      .theme-neutral .ref-img { transition:transform 0.55s ease !important; }
      .theme-neutral .ref-card:hover .ref-img { transform:scale(1.04) !important; }
    `,
  },

  "edgy-dark": {
    T: {
      headerBg: "#0E0E0F",
      headerText: "#FFFFFF",
      accent: "#FFFFFF",
      accentFg: "#0E0E0F",
      radius: "4px",
      badgeRadius: "2px",
      dark: true,
      brutalistShadow: "none",
      cardLayout: "dark",
    },
    bodyBg: "#0E0E0F",
    scopedCSS: `
      /* New Bloom type system: Syne for text, Instrument Serif for headlines (fonts come from FontLoader). */
      .theme-edgy-dark { font-family:'Syne',sans-serif; }
      .theme-edgy-dark h1,.theme-edgy-dark h2 { font-family:'Instrument Serif',Georgia,serif; font-weight:400; letter-spacing:-0.015em; line-height:.95; text-transform:uppercase; }
      .theme-edgy-dark h3,.theme-edgy-dark h4 { font-family:'Syne',sans-serif; font-weight:700; letter-spacing:-0.01em; }
      .theme-edgy-dark em { font-family:'Instrument Serif',Georgia,serif; font-style:italic; }
      .theme-edgy-dark .btn-pink,.theme-edgy-dark .btn-green,.theme-edgy-dark .btn-ghost,.theme-edgy-dark .btn-yellow { font-family:'Syne',sans-serif !important; font-weight:600 !important; }
      .theme-edgy-dark .inp { font-family:'Syne',sans-serif !important; }
      .theme-edgy-dark {
        /* surfaces */
        --offwhite:#0E0E0F; --white:#171718; --surface:#202022; --bg:#0E0E0F;
        --border:rgba(255,255,255,0.10); --border-mid:rgba(255,255,255,0.20);
        --ink:#F5F5F5; --ink-soft:rgba(245,245,245,0.58); --text2:rgba(245,245,245,0.78);
        /* accent: white-on-black, as before */
        --teal:#FFFFFF; --teal-deep:#E8E3DC; --teal-light:rgba(255,255,255,0.07); --teal-mid:rgba(255,255,255,0.18);
        --pink:rgba(255,255,255,0.05); --pink-deep:rgba(255,255,255,0.10);
        --pink-btn:#FFFFFF; --pink-btn-h:#E8E3DC;
        --blue:rgba(255,255,255,0.04); --yellow:rgba(255,255,255,0.06);
        --yellow-deep:rgba(255,255,255,0.14); --blue-deep:rgba(255,255,255,0.14);
        /* status colours, lifted so they read on a dark ground */
        --red:#F97066; --red-light:rgba(249,112,102,0.14); --danger-bd:rgba(249,112,102,0.45);
        --green:#47CD89; --green-bg:rgba(71,205,137,0.14); --ok-bd:rgba(71,205,137,0.4);
        --warn-bg:rgba(247,144,9,0.14); --warn-bd:rgba(247,144,9,0.45); --warn-fg:#FEC84B;
        --info-bg:rgba(46,144,250,0.16); --info-bd:rgba(46,144,250,0.45); --info-fg:#84CAFF;
        --head-bg:#1B1B1D; --row-line:rgba(255,255,255,0.07); --sel-bg:rgba(255,255,255,0.06);
        --on-accent:#0E0E0F; --on-ink:#0E0E0F; --overlay:rgba(0,0,0,0.72); --star:#FDB022;
        --grad-hero:#1B1B1D; --grad-accent:#FFFFFF; --grad-warm:#1B1B1D; --grad-promo:#26262A; --butter:#26262A; --butter-deep:#2F2F34;
        --r:4px; --shadow-sm:none; --shadow:0 8px 24px rgba(0,0,0,0.5);
      }
      .theme-edgy-dark .btn-pink,.theme-edgy-dark .btn-green { background:#FFFFFF !important; color:#0E0E0F !important; border-color:#FFFFFF !important; border-radius:4px !important; box-shadow:none !important; }
      .theme-edgy-dark .btn-pink:hover,.theme-edgy-dark .btn-green:hover { background:#E8E3DC !important; transform:none !important; opacity:1 !important; }
      .theme-edgy-dark .btn-yellow { background:transparent !important; color:#F5F5F5 !important; border-color:rgba(255,255,255,0.5) !important; border-radius:4px !important; box-shadow:none !important; }
      .theme-edgy-dark .btn-ghost { background:transparent !important; border-radius:4px !important; box-shadow:none !important; border-color:rgba(255,255,255,0.25) !important; color:rgba(245,245,245,0.85) !important; }
      .theme-edgy-dark .btn-ghost:hover,.theme-edgy-dark .btn-yellow:hover { background:rgba(255,255,255,0.08) !important; border-color:rgba(255,255,255,0.5) !important; transform:none !important; }
      .theme-edgy-dark .inp { border-radius:4px !important; background:#171718 !important; color:#F5F5F5 !important; border-color:rgba(255,255,255,0.22) !important; }
      .theme-edgy-dark .inp:focus { border-color:rgba(255,255,255,0.7) !important; box-shadow:none !important; transform:none !important; }
      .theme-edgy-dark .inp::placeholder { color:rgba(245,245,245,0.38) !important; }
      .theme-edgy-dark select.inp option { background:#171718; color:#F5F5F5; }
      .theme-edgy-dark .pill { border-radius:2px !important; background:rgba(255,255,255,0.10) !important; color:#F5F5F5 !important; }
      .theme-edgy-dark .card { border-radius:4px !important; box-shadow:none !important; background:#171718 !important; border:1px solid rgba(255,255,255,0.10) !important; }
      .theme-edgy-dark .upi-btn { border-radius:4px !important; background:#202022 !important; border-color:rgba(255,255,255,0.15) !important; color:rgba(245,245,245,0.7) !important; }
      .theme-edgy-dark .upi-btn:hover { border-color:rgba(255,255,255,0.6) !important; background:rgba(255,255,255,0.06) !important; color:#fff !important; }
      .theme-edgy-dark .upload-zone { border-radius:4px !important; border-color:rgba(255,255,255,0.20) !important; }
      .theme-edgy-dark .bdg-green { border-radius:2px !important; }
      .theme-edgy-dark .prod-card:hover { box-shadow:0 0 0 1px rgba(255,255,255,0.5) !important; }
      .theme-edgy-dark .dark-prod-card:hover img { transform:scale(1.03); }
      .theme-edgy-dark .dark-prod-card { transition:outline 0.15s; }
      .theme-edgy-dark .dark-prod-card:hover { outline:1px solid rgba(255,255,255,0.35); }
      .theme-edgy-dark ::-webkit-scrollbar-track { background:#0E0E0F; }
      .theme-edgy-dark ::-webkit-scrollbar-thumb { background:rgba(255,255,255,0.2); }
    `,
  },

};

export function getTheme(template) {
  return THEMES[template] || THEMES.default;
}

export const TEMPLATE_OPTIONS = [
  { id: "default",   label: "Bloom",      desc: "Light & clean — the Bloom look",         preview: { bg: "#F4F3EE", accent: "#2F63DD", radius: "4px",  dark: false } },
  { id: "neutral",   label: "Neutral",    desc: "Clean & editorial — product first",      preview: { bg: "#FFFFFF", accent: "#111111", radius: "4px",  dark: false } },
  { id: "edgy-dark", label: "Black",       desc: "Dark & minimal — editorial edge",        preview: { bg: "#0E0E0F", accent: "#FFFFFF", radius: "4px",  dark: true  } },
];

// ── Storefront font choice (default-template stores only) ──────────────────────────────────────────
// "classic" = whatever the template already does (Neutral/Black: tall condensed serif, uppercase). The others override the
// store name, section headings and product names inside that store's own page only. Ids are mirrored in the backend
// (STORE_FONT_IDS in server.js) — add a font in both places.
export const STORE_FONTS = [
  { id: "classic",   label: "Classic",   desc: "Tall condensed serif",    family: null },
  { id: "clean",     label: "Clean",     desc: "Modern, easy to read",    family: "'DM Sans',system-ui,sans-serif", weight: 600, spacing: "-0.01em" },
  { id: "editorial", label: "Editorial", desc: "Elegant magazine serif",  family: "'Playfair Display',Georgia,serif", weight: 600, spacing: "-0.005em" },
  { id: "soft",      label: "Soft",      desc: "Friendly and rounded",    family: "'Nunito',system-ui,sans-serif", weight: 800, spacing: "0" },
];

export const normalizeStoreFont = (id) => (STORE_FONTS.some(f => f.id === id) ? id : "classic");

const FONT_CSS_URL = "https://fonts.googleapis.com/css2?family=DM+Sans:wght@500;600;700&family=Playfair+Display:wght@500;600;700&family=Nunito:wght@600;800&display=swap";
let _fontLink = null;
// Adds the stylesheet once, only when a store actually uses (or previews) one of these fonts.
export function loadStoreFonts() {
  if (_fontLink || typeof document === "undefined") return;
  _fontLink = document.createElement("link");
  _fontLink.rel = "stylesheet"; _fontLink.href = FONT_CSS_URL;
  document.head.appendChild(_fontLink);
}

// CSS scoped to the wrapper's `.sf-font-<id>` class. !important because several headings carry inline Instrument Serif / uppercase.
export function storeFontCSS(id) {
  const f = STORE_FONTS.find(x => x.id === id);
  if (!f || !f.family) return "";
  const s = `.sf-font-${f.id}`;
  return `${s} h1,${s} h2,${s} h3,${s} h4,${s} .sf-pname,${s} .serif{font-family:${f.family} !important;font-weight:${f.weight} !important;text-transform:none !important;letter-spacing:${f.spacing} !important;line-height:1.15 !important;}`;
}
